import styled from "styled-components";
import { Card, Modal } from "antd";

export const Container = styled.div`
  width: 100%;
  height: 100%;
  padding: 0;
  border-radius: 4px;
  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: 600;
    text-transform: uppercase;
    color: var(--velotax-font-color-ghost);
  }
  .original-price {
    display: grid;
    max-width: 150px;
  }
  .price {
    display: flex;
    width: 100%;
    column-gap: 8px;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 24px;
    h4 {
      font-size: 22px;
      margin: 8px 0 !important;
      color: var(--ant-primary-color);
      del,
      span.per-month {
        font-size: 14px;
      }
      del {
        opacity: 0.8;
        color: var(--velotax-font-color);
      }
    }
    .ant-typography-danger {
      font-size: 11px;
      text-align: right;
      max-width: 120px;
    }
  }
  .ant-divider.ant-divider-horizontal {
    margin: 16px 0;
  }
  .other-features,
  .included-features-user {
    .feature {
      display: flex;
      align-items: center;
      justify-content: start;
      opacity: 0.7;
      margin: 6px 0;
      column-gap: 16px;
      span {
        font-weight: 500;
        display: flex;
        column-gap: 4px;
        align-items: center;
        svg {
          min-width: 20px;
          min-height: 20px;
        }
      }
      svg.fill {
        fill: var(--velotax-font-color);
      }
      svg:not(.fill) {
        stroke: var(--velotax-font-color);
      }
      &.disabled {
        opacity: 0.4;
      }
      .feature-desc {
        display: block;
        font-size: 10px;
        font-weight: 400;
      }
    }
  }
  .other-features {
    margin-bottom: 24px;
  }

  @media only screen and (max-device-width: 812px) {
    .original-price {
      font-size: 14px;
      max-width: 100px;

      .per-month {
        font-size: 12px !important;
      }
    }
  }
`;

export const PlanModalStyled = styled(Modal)`
  .ant-modal-body {
    padding: 24px 32px !important;
  }

  .ant-tabs {
    width: 100%;
  }

  .ant-tabs-nav {
    margin: 0 auto 8px !important;
    width: calc(100% - 16px) !important;
  }

  @media only screen and (max-device-width: 812px) {
    .ant-modal-body {
      padding: 16px !important;
    }
  }
`;

export const Content = styled.div``;

export const Loading = styled.div`
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  border-radius: 8px;
  position: absolute;
  align-items: center;
  justify-content: center;
  background-color: var(--velotax-shadow-default);
`;

export const Feature = styled.div`
  display: flex;
  align-items: center;
`

export const CardStyled = styled(Card)<{
  checked: boolean;
}>`
  position: relative;
  border-radius: 8px;
  transition: .3s;
  border-color: ${({ checked }) => checked ? 'var(--ant-primary-color)' : ''};
  
  &:hover {
    border-color: var(--ant-primary-color);
    transition: .3s;
  }
`

export const Interval = styled.p`
  color: var(--ant-primary-color);
  font-weight: 500;
  font-size: 16px;
  margin-bottom: 1rem;
`
export const Price = styled.p`
  font-weight: 600;
  font-size: 40px;
  margin: 0;
`
export const Info = styled.p`
  font-size: 13px;
  transform: translateY(-8px);
  margin: 0;
`

export const Radio = styled.div<{
  checked: boolean
}>`
  position: absolute;
  right: 1rem;
  top: 1rem;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${({ checked }) => checked ? 'var(--ant-primary-color)' : 'var(--ghost)'};
`

